export const theme = { 
    fontFamily: 'inherit',
    // colors: {
    //     green: ['#E6F6F2','#B3E4D7','#9ADBC9','#81D3BC','#4FC1A1','#35B893','#03A678','#03956C','#027454','#02533C']
    // },
    primaryColor: 'green'
}